'use strict';

const { h } = require('phy');

function LeaderboardBanner({
  imageUrl,
  advert: { destination, leaderboard },
  outerClassName = '',
}) {
  return h(
    `.leaderboard-banner.${outerClassName}`,
    {
      'data-bhw': 'leaderboard-banner',
    },
    h(
      '.banner-content',
      {
        style: {
          'background-image': `url(${imageUrl})`,
        },
      },
      h(
        '.banner-title',
        {
          style: {
            color: `#${leaderboard.leaderboardTextColour}`,
          },
        },
        leaderboard.title
      ),
      h(
        'a.btn.btn-transparent.banner-button',
        {
          href: destination,
          style: {
            color: `#${leaderboard.leaderboardButtonColour}`,
          },
        },
        leaderboard.leaderboardButtonText
      )
    )
  );
}

module.exports = LeaderboardBanner;
